import Image from "next/image";
import React, { useEffect, useState } from "react";
import style from "./style.module.css";


function formatDate(date, language) {
  const monthsEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthsAr = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  let monthName;
  if (language === 'ar') {
    monthName = monthsAr[monthIndex];
    return `${monthName} ${year}`;
  } else {
    monthName = monthsEn[monthIndex];
    return `${day} ${monthName} ${year}`;
  }
}

function index({ image, name, date, bio, lang }) {
  const dates = new Date(date);
  let formattedDate;

  formattedDate = formatDate(dates, lang);

  return (
    <div className={style.con}>
      <div className={style.imgCon}>
        <span className={style.img}>
          <Image
            className={style.img}
            src={image}
            alt={name}
            width={45}
            height={45}
          />
        </span>
        <span className={style.content}>
          <span className={style.name}>{name}</span>
          <span className={style.bio}>{bio}</span>
        </span>
      </div>
      <span>{formattedDate}</span>
    </div>
  );
}

export default index;
